import React from 'react';
import {Stack, IconButton, Typography} from '@mui/material';
import {XIcon, ArrowLeft} from 'lucide-react';
import PropTypes from 'prop-types';
import {WHITE_100, DARK_TEXT_COLOR} from '../../theme';

export const HEADER_HEIGHT = '2.25rem';

export const DrawerHeader = ({onClose, children, sx}) => {
  const shouldDisplayCloseIcon = onClose && typeof onClose === 'function';
  return (
    <Stack
      direction="column"
      position="sticky"
      top={0}
      bgcolor={WHITE_100}
      zIndex={999}
      sx={sx}
    >
      <Stack
        direction="row"
        alignItems="center"
        height={HEADER_HEIGHT}
        bgcolor={WHITE_100}
        flex={1}
        paddingX={2}
        paddingY={1.5}
        justifyContent="space-between"
        align-items="center"
      >
        {children}
        {shouldDisplayCloseIcon && (
          <IconButton onClick={onClose}>
            <XIcon size={20} />
          </IconButton>
        )}
      </Stack>
    </Stack>
  );
};

DrawerHeader.propTypes = {
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
};

export const DrawerHeaderTitle = ({title, onBack, children}) => {
  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <IconButton onClick={onBack} sx={{p: 0.5}}>
        <ArrowLeft size={20} stroke={DARK_TEXT_COLOR} strokeWidth={1.5} />
      </IconButton>
      <Typography
        variant="h3"
        sx={{fontWeight: 500, lineHeight: '150%', color: DARK_TEXT_COLOR}}
      >
        {children || title}
      </Typography>
    </Stack>
  );
};

DrawerHeaderTitle.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  onBack: PropTypes.func.isRequired,
};
